import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { AdminClientResponseType, AdminPropertyResponseType } from "../types";

interface RegisterState {
  registrationSidebarSelectorState: string | null;
  allProperties: AdminPropertyResponseType;
  allClients: AdminClientResponseType;
  setRegistrationSidebarSelectorState: (state: string | null) => void;
  setAllProperties: (properties: AdminPropertyResponseType) => void;
  setAllClients: (clients: AdminClientResponseType) => void;
}

export const useRegisterStore = create<RegisterState>()(
  devtools(
    persist(
      (set) => ({
        registrationSidebarSelectorState: null,
        allProperties: [],
        allClients: [],
        setRegistrationSidebarSelectorState: (state: string | null) => {
          set(() => ({ registrationSidebarSelectorState: state }));
        },
        setAllProperties: (properties: AdminPropertyResponseType) => {
          set(() => ({ allProperties: properties }));
        },
        setAllClients: (clients: AdminClientResponseType) => {
          set(() => ({ allClients: clients }));
        },
      }),
      {
        name: "resgiter-storage",
      }
    )
  )
);
